export const time = () => {
  const timeButton = document.querySelector(".time__button");
  const timeModal = document.querySelector(".time__modal");
  const closeButton = document.querySelector(".time__modal-close");

  if (timeModal && timeModal.dataset.type !== `markup`) {
    function openModal(event) {
      timeModal.classList.add("time__modal--opened");
    }

    function closeModal(event) {
      timeModal.classList.remove("time__modal--opened");
    }

    if (timeButton) {
      timeButton.addEventListener("click", openModal);
    }

    if (closeButton) {
      closeButton.addEventListener("click", closeModal);
    }
  }
};

export const timeUpdate = () => {
  const timeButton = document.querySelector(".js-time-button");
  const timeModal = document.querySelector(".js-time-modal");

  if (timeModal && timeModal.dataset.type === `markup`) {
    const addTimeField = timeModal.querySelector(".js-time-append");
    const addTimeButton = timeModal.querySelector(".js-add-time");
    const closeButton = timeModal.querySelector(".js-time-close");
    const closeAppendButton = timeModal.querySelector(".js-append-close");

    function openModal(event) {
      timeModal.classList.add("time__modal--opened");
    }

    function closeModal(event) {
      timeModal.classList.remove("time__modal--opened");
    }

    function showAddTimeFields(event) {
      addTimeField.classList.add("time__modal-append--show");
    }

    function hideAddTimeFields(event) {
      addTimeField.classList.remove("time__modal-append--show");
    }

    if (timeButton) {
      timeButton.addEventListener("click", openModal);
    }

    if (closeButton) {
      closeButton.addEventListener("click", closeModal);
    }

    if (addTimeButton) {
      addTimeButton.addEventListener("click", showAddTimeFields);
    }

    if (closeAppendButton) {
      closeAppendButton.addEventListener("click", hideAddTimeFields);
    }
  }
};
